import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import "../Style/home&about.css";
import "../Style/services.css";
import NavbarTag from "react-bootstrap/Navbar";
import { PRODUCT_PAGE_TOP_SECTIONS, HOME_PAGE_LLM_BRANCH } from "./homePageNav";
import { fetchAndDisplayText } from "./ReadAndFetchText";
import { HomeK8sArticleBlocks } from "./homeK8sMarkdown";
import automate_k8s_txt from "../Text/automate_k8s.txt";
import automate_k8s_json from "../Text/automate_k8s.json";
import homeK8sSectionsMd from "../Text/Home/home-k8s-sections.md";
import { K8sIcon } from "../Diagrams/K8sDiagrams";

const Products = () => {
  const [automate_k8s_txt_content, setAutomateK8sText] = useState("");
  const [homeK8sSectionsContent, setHomeK8sSectionsContent] = useState("");
  useEffect(() => {
    fetchAndDisplayText(automate_k8s_txt, setAutomateK8sText);
  }, []);
  useEffect(() => {
    fetchAndDisplayText(homeK8sSectionsMd, setHomeK8sSectionsContent);
  }, []);

  return (
    <div className="main-section products-layout">
      <section>
        <NavbarTag expand="lg">
          <NavLink end to="/" className="listItem" activeclassname="activeItem">
            Home
          </NavLink>
          <NavLink to="/about" className="listItem" activeclassname="activeItem">
            About
          </NavLink>
          <NavLink to="/contact" className="listItem" activeclassname="activeItem">
            Contact
          </NavLink>
          <NavLink to="/products" className="listItem" activeclassname="activeItem">
            Products
          </NavLink>
          <NavLink to="/services" className="listItem" activeclassname="activeItem">
            Services
          </NavLink>
        </NavbarTag>
      </section>

      <div className="services-layout-body">
        <aside className="services-tree" aria-label="Page sections">
          <div className="services-tree-title">On this page</div>
          <ul className="services-tree-list">
            {PRODUCT_PAGE_TOP_SECTIONS.map(({ id, label }) => (
              <li key={id}>
                <a href={`#${id}`} className="services-tree-link">
                  {label}
                </a>
              </li>
            ))}
            <li className="services-tree-branch">
              <span className="services-tree-label">{HOME_PAGE_LLM_BRANCH.label}</span>
              <ul className="services-tree-nested">
                {HOME_PAGE_LLM_BRANCH.items.map(({ id, label }) => (
                  <li key={id}>
                    <a href={`#${id}`} className="services-tree-link">
                      {label}
                    </a>
                  </li>
                ))}
              </ul>
            </li>
          </ul>
        </aside>

        <div className="services-outlet home-main-column">
          <section className="contentBox">
            <div id="products-overview">
              <h1>Products</h1>
              <h2 className="products-k8s-headline">
                {automate_k8s_json.title_1}{" "}
                <K8sIcon size={36} /> Kubernetes <K8sIcon size={36} />{" "}
                {automate_k8s_json.title_2}
              </h2>
              <p>{automate_k8s_txt_content}</p>
            </div>

            {homeK8sSectionsContent ? (
              <div className="services-markdown home-k8s-article-md">
                <HomeK8sArticleBlocks markdownSource={homeK8sSectionsContent} />
              </div>
            ) : null}
          </section>
        </div>
      </div>
    </div>
  );
};

export default Products;
